// extracted by mini-css-extract-plugin
export default {"cta":"CtaLink_cta__cBDh9","ctaLink":"CtaLink_ctaLink__+ANTM"};